module.exports = __webpack_public_path__ + "static/img/cCT7.03e6e51b.png";